import { Box, ClickAwayListener, Fade, Paper, Popper, Tooltip, Typography } from "@mui/material";
import React, { useState } from "react";
import "./styles.css";
import StatusIndicator from "../../components/StatusIndicator";
import StatusSelectBoxDefault from "../../components/StatusSelectBoxDefault";
import OwnerSelectBox from "../../components/OwnerSelectBox";
import DepartmentSelectBox from "../../components/DepartmentSelectBox";
import PerfActionDateSelector from "../../components/PerfActionDateSelector";
import { t } from "i18next";
import TasksTable from "../../components/TasksTable";
import PerfActionStandardsTable from "../../components/PerfActionStandardsTable";
import { CommentsOverviewBox } from "../CommentsOverviewBox";
import { ReportComment } from "../ReportComment";
import TextFieldDefault from "../../components/TextFieldDefault";
import StatusSelectBoxPNAD from "../../components/StatusSelectBoxPNAD";
import TextAreaDefault from "../../components/TextAreaDefault";
import PerformanceActionsTable from "../../components/PerformanceActionsTable";
import { TextAreaPerformanceAction } from "../../components/TextAreaPerformanceAction";
import { TextFieldProject } from "../../components/TextFieldProject";
import { addProject, editProject } from "../../api/projects";
import { ProjectSelectBoxDefault } from "../../components/ProjectSelectBoxDefault";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedGoal, setSelectedSubGoal } from "../../redux/reducers/goalsAndStrategy";
import StatusBox from "../../components/StatusBox";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";

const NewProjectDetailPopperGoals = (props:any) => {
    const { isOpen, handleClickAway, goalId } = props;
    const [newProjectData, setNewProjectData]:any = useState({});
    const selectedGoal = useSelector((state:any) => state.goalsAndStrategy.selectedGoal);
    const selectedSubGoal = useSelector((state:any) => state.goalsAndStrategy.selectedSubGoal);
    const [isUpdatedData, setIsUpdatedData] = useState(false);
    const dispatch = useDispatch();
    
    const handleClickInsidePopper = (event: MouseEvent) => {
        event.stopPropagation();
    }

    const addNewProject = async () => {
        var response:any;
        if (Object.keys(newProjectData).includes('id') && newProjectData?.id > 0) {
            response = await editProject({ projectId: newProjectData?.id, project: {...newProjectData, actions: [], goalId: goalId } });
        } else {
            response = await addProject({ project: {...newProjectData, actions: [], goalId: goalId } });
        }
        if(selectedSubGoal !== null) {
            const tempObj = { ...selectedSubGoal, projects: [...selectedSubGoal.projects, response] };
            dispatch(setSelectedSubGoal(tempObj));
        } else {
            const tempObj = { ...selectedGoal, projects: [...selectedGoal.projects, response] };
            dispatch(setSelectedGoal(tempObj));
        }
    }

    //handling other changes
    const handleChangeState = (updatedData:any) => {
        var tempObj = { ...newProjectData, ...updatedData };
        setNewProjectData(tempObj);
        setIsUpdatedData(true);
    }

    const manageClickAway = () => {
        Object.keys(newProjectData).length > 0 &&
        Object.values(newProjectData).some(value => value !== null && value !== '') &&
        addNewProject();
        setNewProjectData({});
        handleClickAway(newProjectData, isUpdatedData);
    }

    return (
        <React.Fragment>
            <Popper className='popperStyle' open={isOpen} transition>
                {({ TransitionProps }) => (
                    <ClickAwayListener onClickAway={manageClickAway}>
                        <Fade {...TransitionProps} timeout={350}>
                            <Paper sx={{ p: 2, width: '1200px', height: 'auto', overflowY: 'auto', margin: 'auto', mt: '25vh' }} onClick={() => handleClickInsidePopper}>
                                <Box className={'NPDmainWrapper'}>
                                    <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                                        <Typography className="fs14 fw700 maxWidth70p uppercase">{t('NEW_PROJECT')}</Typography>
                                        <Tooltip title={t('DELETE_AND_DISCARD')} arrow placement='top'>
                                            <FontAwesomeIcon onClick={() => { setNewProjectData({}); handleClickAway(null, isUpdatedData); }} className={'icon mr10 deleteIcon mtbAuto'} icon={faTrashCan}/>
                                        </Tooltip>
                                    </Box>
                                    <Box className={'mt30'}>
                                        <ProjectSelectBoxDefault 
                                        value={newProjectData?.name}
                                        manageSelect={handleChangeState} />
                                    </Box>
                                    <Box className={'mt30'}>
                                        <TextAreaPerformanceAction 
                                        label={t('PROJECT_DESCRIPTION')}
                                        value={newProjectData?.description}
                                        handleChange={handleChangeState}
                                        />
                                    </Box>
                                    <Box className={'NPDselectBoxWrapper'}>
                                        <OwnerSelectBox value={newProjectData?.assigneeUserId} manageSelect={handleChangeState} dataLabel={'assigneeUserId'} />
                                        <DepartmentSelectBox value={newProjectData?.departmentId} manageSelect={handleChangeState} />
                                        <StatusBox reportType={'rabg'} status={newProjectData?.status != null ? newProjectData?.status : 4} />
                                        <PerfActionDateSelector value={newProjectData?.startDate} manageSelect={handleChangeState} dataLabel={'startDate'} label={t('START_DATE')}/>
                                        <PerfActionDateSelector value={newProjectData?.dueDate} manageSelect={handleChangeState} />
                                    </Box>
                                    {/* <Box className={'mt30'}>
                                        <Typography className="fs13 fw700 uppercase">{t('ACTIONS')}</Typography>
                                        <PerformanceActionsTable data={newProjectData?.actions ? newProjectData?.actions : []} />
                                    </Box> */}
                                    {/* <Box className={'mt30'}>
                                        <Typography className="fs13 fw700 uppercase">{t('COMMENTS')}</Typography>
                                        <Box sx={{ display: "flex" }}>
                                            <Box sx={{ width: '30%' }}>
                                                <CommentsOverviewBox manageClick={() => {}} parentComponent={'jlEval'} />
                                            </Box>
                                            <Box sx={{ width: '70%' }}>
                                                <ReportComment />
                                            </Box>
                                        </Box>
                                    </Box> */}
                                </Box>
                            </Paper>
                        </Fade>
                    </ClickAwayListener>)}
            </Popper>
        </React.Fragment>
    )
}

export default NewProjectDetailPopperGoals;